// extracted by mini-css-extract-plugin
export default {"title":"Newest_title__YwBXM","carouselContainer":"Newest_carouselContainer__f9IEG","carouselItem":"Newest_carouselItem__X4+N2","arrow":"Newest_arrow__OCNgR"};